import CustomerPostSanctionDocs from "../../../jsx/components/Dashboard/CustomerPostSanctionDocs/CustomerPostSanctionDocs";

const CustomerPostSanctionDocsWrapper = () => {
  return <CustomerPostSanctionDocs />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(CustomerPostSanctionDocsWrapper);
